module.exports = __webpack_public_path__ + "img/chongqing.0b7ac4de.png";